module.exports = __webpack_public_path__ + "static/media/zoom-out.2d0a983a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoom-out.svg
// module id = 1818
// module chunks = 0